import { CommonType } from "./common.type";

export interface Campaign extends CommonType {
  id: number;
  name: string;
  startDate: number;
  endDate: number;
  discount: number;
  isActive?: boolean;
  testingIds?: string[] | number[] | null;
  targets: {
    gender: string[];
    birthday: boolean;
    userType: string[];
    rangePrice: number[];
    userListenedToMinutes?: number;
    kasIsGreaterThan?: number;
    kasIsLessThan?: number;
    hasPurchasedBooks?: number[];
    notHasPurchasedBooks?: number[];
  };
}

export interface CampaignNotification extends CommonType {
  messageKey: string;
  title: string;
  body: string;
  note: string;
  rightIcon: string | null;
  timeSend: string | null;
  repeatDays: string | null;
  isActive?: boolean;
  testingIds?: string[] | number[] | null;
  targets: {
    birthday: boolean;
    userType: string[];
    userListenedToMinutes?: number;
    kasIsGreaterThan?: number;
    kasIsLessThan?: number;
    hasPurchasedBooks?: number[];
    notHasPurchasedBooks?: number[];
  };
}

export interface CampaignPopupBanner extends CommonType {
  id: number;
  content: string;
  userType: number;
  media: string;
  startDate: string | null;
  endDate: string | null;
  buttonTitle: string;
  buttonAction: string;
  totalDisplayCount: number;
  totalDisplayTime: number;
  isActive?: boolean;
  testingIds?: string[] | number[] | null;
  targets: {
    birthday: boolean;
    userType: string[];
    userListenedToMinutes?: number;
    kasIsGreaterThan?: number;
    kasIsLessThan?: number;
    hasPurchasedBooks?: number[];
    notHasPurchasedBooks?: number[];
  };
}

export interface CreateCampaign {
  campaign: {
    name: string;
    discount: number;
    startDate: string;
    endDate: string;
    testingIds?: string;
    targets: {
      birthday: boolean;
      userType: string[];
      rangePrice?: number[];
      userListenedToMinutes?: number;
      kasIsGreaterThan?: number;
      kasIsLessThan?: number;
      hasPurchasedBooks?: number[];
      notHasPurchasedBooks?: number[];
    };
  };
  notification: {
    title: string;
    body: string;
    note: string;
    rightIcon: string;
    timeSend: string;
    repeatDays: string[];
    testingIds?: string;
  };
  popupBanner: {
    content: string;
    userType: number;
    media: string;
    startDate: string;
    endDate: string;
    buttonTitle: string;
    buttonAction: string;
    totalDisplayCount: number;
    totalDisplayTime: number;
    testingIds?: string;
  };
}

export interface UpdateCampaign {
  campaign: {
    id: number;
    name: string;
    discount: number;
    startDate: string;
    endDate: string;
    testingIds?: string;
    targets: {
      birthday: boolean;
      userType: string[];
      rangePrice?: number[];
      userListenedToMinutes?: number;
      kasIsGreaterThan?: number;
      kasIsLessThan?: number;
      hasPurchasedBooks?: number[];
      notHasPurchasedBooks?: number[];
    };
  } | null;
  notification: {
    messageKey: string;
    title: string;
    body: string;
    note: string;
    rightIcon: string;
    timeSend: string;
    repeatDays: string[];
    testingIds?: string;
  } | null;
  popupBanner: {
    id: number;
    content: string;
    userType: number;
    media: string;
    startDate: string;
    endDate: string;
    buttonTitle: string;
    buttonAction: string;
    totalDisplayCount: number;
    totalDisplayTime: number;
    testingIds?: string;
  } | null;
}

export enum TypeToggleStatus {
  CAMPAIGN = "campaign",
  NOTIFICATION = "notification",
  POPUP_BANNER = "popupBanner",
}

export interface PushNotificationTest {
  title: string;
  body: string;
  rightIcon: string;
  testingIds: string;
}
